import { KeyboardEvent, useEffect, useState } from "react";
import { ShareDataModalContainer } from "../shareDataModal.styles";
import { Button, Input, Radio, Select, Tag, message } from "antd";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CloseOutlined } from "@ant-design/icons";
import { DataIndexItem } from "../../../../../types/interfaces";
import PermissionAccessDetail from "./PermissionAccessDetail";
import { DataStore } from "../../../../../store/DataStore";
import { useSnapshot } from "valtio";

const { Option } = Select;
// Define an enum for the radio button options
enum RadioOptions {
    owner = "owner",
    group = "group",
    data = "data"
}

interface DropdownDetails {
    id: string;
    name: string | null;
}

interface ShareDetailProps {
    handleCancel: () => void;
    selectedItems?: DataIndexItem[];
}

// const ShareDetails = () => {
const ShareDetails = ({ handleCancel, selectedItems }: ShareDetailProps) => {
    const [selectedType, setSelectedType] = useState<RadioOptions>(RadioOptions.owner);
    const [emailList, setEmailList] = useState<string[]>([]);
    const [selectedValue, setSelectedValue] = useState<string>('');
    const [ownerList, setOwnerList] = useState<DropdownDetails[]>([]);
    const [groupList, setGroupList] = useState<DropdownDetails[]>([]);
    const [dataList, setDataList] = useState<DropdownDetails[]>([]);
    const [dropdownList, setDropdownList] = useState<DropdownDetails[]>([]);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>('');
    const [selectedValues, setSelectedValues] = useState<string[]>([]);
    const [checkedItems, setCheckedItems] = useState({
        view: true,
        process: false,
        download: false,
        share: false
    });
    const snap = useSnapshot(DataStore);

    const onTypeChange = (e: any) => {
        const newType = e.target.value as RadioOptions;
        setSelectedType(newType);
        updateDropdownList(newType);
        setCheckedItems({
            view: true,
            process: false,
            download: false,
            share: false
        });
    };

    const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            if (inputValue.trim() === "") {
                message.warning('Input is empty. Please type something.');
                return;
            }
            if (emailList.length >= 10) {
                message.warning('Cannot add more than 10 emails.');
                return;
            }
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(inputValue)) {
                message.error('Invalid email format.');
                return;
            }
            if (emailList.includes(inputValue)) {
                message.warning('Email is already added.');
                return;
            }
            setEmailList([...emailList, inputValue]);
            setInputValue('');
        }
    };

    const removeItem = (index: number) => {
        setEmailList(emailList.filter((_, i) => i !== index));
    };

    const handleSelectChange = (values: any) => {
        setSelectedValues(values);
    };

    const handleCheckboxChange = (e: any) => {
        setCheckedItems({
            ...checkedItems,
            [e.target.name]: e.target.checked,
        });
    }

    const updateDropdownList = (type: RadioOptions) => {
        switch (type) {
            case RadioOptions.owner:
                setDropdownList(ownerList);
                setSelectedValues(ownerList?.[0]?.id ? [ownerList[0].id] : []);
                break;
            case RadioOptions.group:
                setDropdownList(groupList);
                setSelectedValues(groupList?.[0]?.id ? [groupList[0].id] : []);
                break;
            case RadioOptions.data:
                setDropdownList(dataList);
                if (selectedItems) {
                    const selectedIds = selectedItems.map(item => item.data_id);
                    setSelectedValues(selectedIds as string[]);
                } else {
                    setSelectedValues(dataList?.[0]?.id ? [dataList[0].id] : []);
                }
                break;
            default:
                setDropdownList([]);
                setSelectedValue('');
                break;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            let data = await DataStore;
            setOwnerList(data?.ownerDetails?.map(owner => ({
                id: owner?.owner_id,
                name: owner?.owner_name || owner?.owner_id
            })));
            setDataList(data?.dataItems?.map(item => ({
                id: item.data_id,
                name: item.name || item.data_id
            })));
            setGroupList([])
            setDropdownList(data?.ownerDetails?.map(owner => ({
                id: owner.owner_id,
                name: owner?.owner_name || owner?.owner_id
            })));
        };

        fetchData();
    }, []);

    useEffect(() => {
        updateDropdownList(selectedType);
    }, [ownerList, groupList, dataList]);

    const handleShareDetails = () => {
        if (emailList.length === 0) {
            message.warning('Please add at least one email.');
            return;
        }

        if (selectedValues.length === 0) {
            message.warning(`Please select ${selectedType}.`);
            return;
        }

        setButtonLoading(true);
        let checkedItemsArray = Object.entries(checkedItems)
            .filter(([key, value]) => value === true)
            .map(([key, value]) => key);

        let data = {
            "action": "share",
            "scope": selectedType,
            "id": selectedValues,
            "perms": checkedItemsArray,
            "emails": emailList
        }
        console.log(data, 'share selected Details');
        setTimeout(() => {
            setButtonLoading(false);
        }, 2000)

        handleCancel()
    }

    useEffect(() => {
        if (selectedItems) {
            setSelectedType(RadioOptions.data);
            updateDropdownList(RadioOptions.data);
        }
    }, [dataList]);

    return (
        <ShareDataModalContainer>
            <div className='share_main_block'>
                <div className="share_data_block">
                    <Radio.Group onChange={onTypeChange} value={selectedType}>
                        {Object.keys(RadioOptions)
                            .map((key) => (
                                <Radio key={key} value={key}>
                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                </Radio>
                            ))}
                    </Radio.Group>
                </div>
                <div className="panel_data_form share_action_box">
                    <div className="share_left_block share_dropdown_Box">
                        <Select
                            mode="multiple"
                            placeholder={selectedType.charAt(0).toUpperCase() + selectedType.slice(1)}
                            value={selectedValues}
                            onChange={handleSelectChange}
                            suffixIcon={<KeyboardArrowDownIcon style={{ color: '#939598', fontSize: '24px' }} />}
                            style={{ width: '100%', marginBottom: '10px' }}
                            popupClassName="custom_tag_dropdown"
                            showSearch
                            optionFilterProp="children"
                        >
                            {dropdownList && dropdownList.length > 0 && dropdownList.map(item => (
                                <Option key={item.id} value={item.id}>
                                    {item.name}
                                </Option>
                            ))}
                        </Select>
                        <div className="email_label_text">{selectedType.charAt(0).toUpperCase() + selectedType.slice(1)}</div>
                        <div className="email_main_block">
                            <Input
                                placeholder="Enter Email"
                                size="large"
                                type="email"
                                value={inputValue}
                                onChange={(e) => setInputValue(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                            <div className="email_tag_box">
                                {emailList.map((item, index) => (
                                    <Tag
                                        key={index}
                                        closable
                                        onClose={() => removeItem(index)}
                                        closeIcon={<CloseOutlined />}
                                    >
                                        <span className="tag_text">{item}</span>
                                    </Tag>
                                ))}
                            </div>
                            <div className="email_label_text">E-mail Id</div>
                        </div>

                    </div>
                    <div className="share_right_block">
                        <p className="access_title">Access</p>
                        <div className="access_block">
                            <PermissionAccessDetail checkedItems={checkedItems} onCheckboxChange={handleCheckboxChange} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="share_footer_box">
                <Button loading={buttonLoading} type="primary" className="ok_batch_button share_footer_btn" onClick={handleShareDetails}>
                    Share
                </Button>
            </div>
        </ShareDataModalContainer>
    );
}

export default ShareDetails;
